import { times } from 'lodash';

const buildConsumerFieldsInitialValues = ({ persistedValues = [], schemas = [], claimedSlots = 1 }) => {
  const slots = claimedSlots ? claimedSlots : 1;
  if (persistedValues.length) return initialValuesFromPersistedValues(persistedValues);
  return initialValuesFromDefaults(slots, schemas);
};

const initialValuesFromPersistedValues = (persistedValues) => {
  const initialValues = [];
  persistedValues.forEach((persisted, index) => {
    const existing = initialValues[persisted.slot - 1] || {};
    initialValues[persisted.slot - 1] = { ...existing, [persisted.name]: persisted.value };
  });
  return initialValues;
}

const initialValuesFromDefaults = (claimedSlots, schemas) => {
  const initialValues = [];
  times(claimedSlots, (index) => {
    initialValues[index] = intialSlotValuesFromDefaults(schemas);
  });
  return initialValues;
}

export const intialSlotValuesFromDefaults = (schemas) => {
  const slot = {};
  schemas.forEach(schema => {
    if (schema.type === 'text' || schema.type === 'textarea') return;
    slot[schema.name] = schema.defaultValue;
  });
  return slot;
}

export default buildConsumerFieldsInitialValues;



// WEBPACK FOOTER //
// ./src/lib/desktop-member-fields-initial-values-builder.js